import { AuthApi } from "api/auth";
import { TOKEN, USERNAME } from "contants";
import { ResponseCode } from "contants/response";
import { handleResetData } from "helpers/handleResetData";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { selectToken, selectUsername, updateIsAuthenticated } from "store/auth";
import { setOpenModal } from "store/modal";

import { useAppDispatch, useAppSelector } from "./app-hook";

export const useVerify = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const username =
    useAppSelector(selectUsername) || localStorage.getItem(USERNAME);
  const token = useAppSelector(selectToken) || localStorage.getItem(TOKEN);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchVerifyToken = useCallback(async () => {
    if (!username || !token) {
      setTimeout(() => {
        navigate("/");
        dispatch(setOpenModal("signin"));
      }, 500);
      return;
    }
    const response = await AuthApi.verifyToken(username, { username, token });
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
    if (response.status === ResponseCode.SUCCESS) {
      dispatch(updateIsAuthenticated(true));
      return;
    }

    handleResetData(dispatch, navigate);
  }, [username]);

  useEffect(() => {
    fetchVerifyToken();
  }, [fetchVerifyToken]);

  return { isLoading };
};
